import React, { useEffect } from "react";
import Cards from "../Components/Projects/Cards";
import Banner from "../Components/Projects/Banner";
import { usePagesBanners } from "../Context/PagesBannersContext";

function Projects() {
  const { isBanner } = usePagesBanners();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);
  return (
    <div className="flex flex-col mx-[2rem] lg:mx-[7rem] md:mx-[4rem] items-center gap-7 overlay">
      <Banner isBanner={isBanner?.data[2]} />
      <Cards />
    </div>
  );
}

export default Projects;
